import { createAsyncThunk } from '@reduxjs/toolkit';
import crmApi, { IResponseGetCustomerJobs } from '~/apis/crm';
import { CREATE_CRM_LEAD, GET_CLIENT_DETAILS, GET_CRM_LIST_VIEW, GET_DOCUMENTS, GET_CUSTOMER_JOBS, UPLOAD_FILE, ADD_NOTE, GET_ACTIVITIES } from '~/utils/constants/actionType';
import { IParamsCRM, IParamsDocuments, IPayloadAddNewLead, IPayloadUploadFile, IResponseAddNewLead, IResponseGetClientDetails, IResponseGetCRMListView, IResponseGetDocuments, IParamsActivities, IResponseGetActivities } from '~/utils/interface/crm';

export const handleGetCRMListView = createAsyncThunk<IResponseGetCRMListView, { params: IParamsCRM }>(
  GET_CRM_LIST_VIEW,
  async ({ params }, { rejectWithValue }) => {
    try {
      const res = await crmApi.getCRMListView(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleCreateCRMLead = createAsyncThunk<IResponseAddNewLead, IPayloadAddNewLead>(
  CREATE_CRM_LEAD,
  async (data: IPayloadAddNewLead, { rejectWithValue }) => {
    try {
      const res = await crmApi.createLead(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetClientDetails = createAsyncThunk<IResponseGetClientDetails, { idClient: string | undefined }>(
  GET_CLIENT_DETAILS,
  async ({ idClient }, { rejectWithValue }) => {
    try {
      const res = await crmApi.getClientDetails(idClient);
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetDocuments = createAsyncThunk<IResponseGetDocuments, { idClient: string | undefined, params: IParamsDocuments }>(
  GET_DOCUMENTS,
  async ({ idClient, params }, { rejectWithValue }) => {
    try {
      const res = await crmApi.getDocuments(idClient, params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleUploadFile = createAsyncThunk<any, { idClient: string , data: IPayloadUploadFile }>(
  UPLOAD_FILE,
  async ({ idClient, data }, { rejectWithValue }) => {
    try {
      const res = await crmApi.uploadFile(idClient, data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetCustomerJobs = createAsyncThunk<IResponseGetCustomerJobs, { customerId: string; params?: any }>(
  GET_CUSTOMER_JOBS,
  async ({ customerId, params }, { rejectWithValue }) => {
    try {
      const res = await crmApi.getCustomerJobs(customerId, params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleAddNote = createAsyncThunk<any, { customerId: string; content: string }>(
  ADD_NOTE,
  async ({ customerId, content }, { rejectWithValue }) => {
    try {
      const res = await crmApi.addNote(customerId, { content });
      return res.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetActivities = createAsyncThunk<IResponseGetActivities, { customerId: string; params?: IParamsActivities }>(
  GET_ACTIVITIES,
  async ({ customerId, params }, { rejectWithValue }) => {
    try {
      const res = await crmApi.getActivities(customerId, params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);